import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import DashboardLayout from "@/pages/dashboard/DashboardLayout";
import Overview from "@/pages/dashboard/Overview";
import Domains from "@/pages/dashboard/Domains";
import DomainDetail from "@/pages/dashboard/DomainDetail";
import Credentials from "@/pages/dashboard/Credentials";
import ApiKeys from "@/pages/dashboard/ApiKeys";
import Logs from "@/pages/dashboard/Logs";
import Inbox from "@/pages/dashboard/Inbox";
import TestConsole from "@/pages/dashboard/TestConsole";
import AdminPanel from "@/pages/admin/AdminPanel";
import DeliverySettings from "@/pages/admin/DeliverySettings";

function Protected({ children, admin }) {
  const { user, ready } = useAuth();
  if (!ready || user === null)
    return <div className="flex min-h-screen items-center justify-center text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/app" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster theme="dark" position="top-right" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/app" element={<Protected><DashboardLayout /></Protected>}>
              <Route index element={<Overview />} />
              <Route path="domains" element={<Domains />} />
              <Route path="domains/:id" element={<DomainDetail />} />
              <Route path="credentials" element={<Credentials />} />
              <Route path="api-keys" element={<ApiKeys />} />
              <Route path="logs" element={<Logs />} />
              <Route path="inbox" element={<Inbox />} />
              <Route path="console" element={<TestConsole />} />
            </Route>
            <Route path="/admin" element={<Protected admin><AdminPanel /></Protected>} />
            <Route path="/admin/delivery" element={<Protected admin><DeliverySettings /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
